import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BillingSetup } from 'src/app/model/billingSetup';



class DataForBillingUpdate {
  billingSetup: BillingSetup = new BillingSetup();
  isRegistrationRequest = false;
}

@Component({
  selector: 'aw-update-billing-dialog',
  templateUrl: './update-billing-dialog.component.html',
  styleUrls: ['./update-billing-dialog.component.scss']
})
export class UpdateBillingDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataForBillingUpdate,
    public dialogRef: MatDialogRef<UpdateBillingDialogComponent>,
  ) {


  }


  ngOnInit(): void {
  }


}


